var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"warning","disabled":!_vm.updatable},on:{"click":_vm.update}},[_c('b-icon',{attrs:{"icon":"arrow90deg-up"}}),_vm._v(" パスワードを変更 ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }